let allowedElements = [];
let blockerActive = false;
let styleElement = null;

const createBlockerStyle = () => {
  if (!styleElement) {
    styleElement = document.createElement('style');
    styleElement.id = 'tutorial-blocker-style';
    styleElement.textContent = `
      body.tutorial-blocker-active * {
        pointer-events: none !important;
        cursor: not-allowed !important;
      }
      body.tutorial-blocker-active .tutorial-enabled-element,
      body.tutorial-blocker-active .tutorial-enabled-element *,
      body.tutorial-blocker-active #header-menu-superior,
      body.tutorial-blocker-active #btn-undo-tools,
      body.tutorial-blocker-active #btn-redo-tools,
      body.tutorial-blocker-active #btn-zoom-out-tools,
      body.tutorial-blocker-active #btn-zoom-in-tools,
      body.tutorial-blocker-active #btn-center-tools,
      body.tutorial-blocker-active #btn-settings-tools,
      body.tutorial-blocker-active #btn-toggle-instrucciones,
      body.tutorial-blocker-active #btn-instruccion-anterior,
      body.tutorial-blocker-active #btn-instruccion-siguiente,
      body.tutorial-blocker-active #btn-accion-principal,
      body.tutorial-blocker-active #btn-close-webserial-modal,
      body.tutorial-blocker-active #btn-apariencia-modo,
      body.tutorial-blocker-active #btn-apariencia-modo *,
      body.tutorial-blocker-active #mui-menu-apariencia,
      body.tutorial-blocker-active #mui-menu-apariencia *,
      body.tutorial-blocker-active #menu-apariencia-modo,
      body.tutorial-blocker-active #menu-apariencia-modo *,
      body.tutorial-blocker-active #select-apariencia-modo,
      body.tutorial-blocker-active #select-apariencia-modo *,
      body.tutorial-blocker-active .MuiSelect-select,
      body.tutorial-blocker-active .MuiSelect-select *,
      body.tutorial-blocker-active .MuiSelect-icon,
      body.tutorial-blocker-active .MuiInputBase-root,
      body.tutorial-blocker-active .MuiInputBase-root *,
      body.tutorial-blocker-active .MuiOutlinedInput-root,
      body.tutorial-blocker-active .MuiOutlinedInput-root *,
      body.tutorial-blocker-active .MuiPopover-root,
      body.tutorial-blocker-active .MuiPopover-root *,
      body.tutorial-blocker-active .MuiBackdrop-root,
      body.tutorial-blocker-active .MuiModal-backdrop,
      body.tutorial-blocker-active .MuiPaper-root,
      body.tutorial-blocker-active .MuiPaper-root *,
      body.tutorial-blocker-active .MuiMenuItem-root,
      body.tutorial-blocker-active .MuiMenuItem-root *,
      body.tutorial-blocker-active .MuiList-root,
      body.tutorial-blocker-active .MuiList-root *,
      body.tutorial-blocker-active .MuiMenu-root,
      body.tutorial-blocker-active .MuiMenu-root *,
      body.tutorial-blocker-active #select-apariencia-modo .MuiMenuItem-root,
      body.tutorial-blocker-active #select-apariencia-modo .MuiMenuItem-root *,
      body.tutorial-blocker-active #menuitem-apariencia-light,
      body.tutorial-blocker-active #menuitem-apariencia-light *,
      body.tutorial-blocker-active #menuitem-apariencia-dark,
      body.tutorial-blocker-active #menuitem-apariencia-dark * {
        pointer-events: auto !important;
        cursor: auto !important;
        overflow: auto !important;
      }
    `;
    document.head.appendChild(styleElement);
  }
};

const getTargetElement = (element) => {
  const tagName = element.tagName;

  if (tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT') {
    return element;
  }

  if (tagName === 'IMG') {
    return element.closest('button, a, [onclick], [role="button"]') || element.parentElement || element;
  }

  const computedStyle = window.getComputedStyle(element);
  if (computedStyle.pointerEvents === 'none') {
    return (
      element.closest('button, a, [onclick], [role="button"], input, textarea, select')
      || element.parentElement
      || element
    );
  }

  return element;
};

const enableElement = (element) => {
  if (!element) return;

  element.classList.add('tutorial-enabled-element');

  if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA' || element.tagName === 'SELECT') {
    // eslint-disable-next-line no-param-reassign
    element.disabled = false;
    // eslint-disable-next-line no-param-reassign
    element.readOnly = false;
    // eslint-disable-next-line no-param-reassign
    element.style.pointerEvents = 'auto';
    // eslint-disable-next-line no-param-reassign
    element.tabIndex = element.tabIndex >= 0 ? element.tabIndex : 0;
  }
};

const disableElement = (element) => {
  if (element) {
    element.classList.remove('tutorial-enabled-element');
  }
};

export const stopElementBlocker = () => {
  blockerActive = false;
  document.body.classList.remove('tutorial-blocker-active');

  allowedElements.forEach(({ domElement }) => {
    disableElement(domElement);
  });

  allowedElements = [];
};

export const startElementBlocker = (hints = [], workspace = null) => {
  stopElementBlocker();

  if (!hints || hints.length === 0) {
    return;
  }

  createBlockerStyle();
  document.body.classList.add('tutorial-blocker-active');
  blockerActive = true;

  hints.forEach((hint) => {
    if (hint.element && hint.element.class) {
      const element = document.querySelector(hint.element.class);

      if (!element) {
        return;
      }

      const targetElement = getTargetElement(element);
      enableElement(targetElement);

      allowedElements.push({
        element: hint.element.class,
        domElement: targetElement,
      });
    }
  });
};

export const isBlockerActive = () => blockerActive;

export const updateAllowedElements = (hints = []) => {
  if (!blockerActive) {
    startElementBlocker(hints);
    return;
  }

  allowedElements.forEach(({ domElement }) => {
    disableElement(domElement);
  });

  allowedElements = [];

  hints.forEach((hint) => {
    if (hint.element && hint.element.class) {
      const element = document.querySelector(hint.element.class);

      if (element) {
        const targetElement = getTargetElement(element);
        enableElement(targetElement);

        allowedElements.push({
          element: hint.element.class,
          domElement: targetElement,
        });
      }
    }
  });
};
